import BaseModel from "../BaseModel";
import ImperativeType from "./ImperativeType";

export default class Imperative extends BaseModel{
    static entity = 'imperatives';
    static fields(){
        return {
            id: this.attr(null),
            customer_id: this.attr(null),
            imperative_type_id: this.attr(null),
            user_id: this.attr(null),
            imperative_type: this.belongsTo(ImperativeType, 'imperative_type_id')
        }
    }
    static ignoredLogFields(){
        return ['created_at', 'updated_at', 'imperative_type']
    }
    static route(){
        return '/imperatives'
    }
}
